
import service from "../services/user.service"; // Asegúrate de que el servicio esté configurado correctamente
import historyService from "../services/userCuadrillaHistory.service";

export const users = {
    namespaced: true,
    state: {
        users: [],
        currentPage: 1,
        lastPage: 1,
        links:[],
        cuadrillaHistory: [],
    },
    getters: {
        allUsers: (state) => state.users,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
        }),
        links: (state) => state.links,
    },
    actions: {
        async fetchUsers({ commit },pageUrl = null) {
            try {
                const response = await service.getUsers(pageUrl); 
                commit('SET_USERS', response.data.data); 
                commit('SET_PAGINATION', {
                    currentPage: response.data.current_page,
                    lastPage: response.data.last_page,
                    links: response.data.links, // Agrega los links de paginación aquí
                });
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        },
        async save(context,data) {
            try {
                let response;
                if(data.id==0){
                    response = await service.createUser(data);
                }else{
                    response = await service.updateUser(data.id,data);
                }
               
                return response; 
            } catch (error) {
                console.error("Error save users:", error);
                return error.response; 
            }
        },
        async delete(context, userId) {
            try {
                const response = await service.deleteUser(userId);
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response; ; // Propaga el error para que sea manejado en el componente
            }
        },
        async getOficios() {
            try {
                const response = await service.getOficios();
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getAll() {
            try {
                const response = await service.getAll('all');
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },  
        async getCuadrillas() {
            try {
                const response = await service.getCuadrillas();
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getCuadrillaHistory({ commit }, userId) {
            try {
                const response = await historyService.getHistory(userId);
                commit('SET_CUADRILLA_HISTORY', response.data);
                return response.data;
            } catch (error) {
                console.error("Error fetching cuadrilla history:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_USERS(state, users) {
            state.users = users;
        },
        SET_PAGINATION(state, pagination) {
            state.currentPage = pagination.currentPage;
            state.lastPage = pagination.lastPage;
            state.links = pagination.links;
        },
        ADD_USER(state, user) {
            state.users.push(user); // Agrega el nuevo usuario al array de usuarios
        },
        SET_CUADRILLA_HISTORY(state, history) {
            state.cuadrillaHistory = history;
        }
    },
};